import { lazy } from 'react';
import AuthRoles from '@/app/auth/authRoles';

const SalesAttritionReportPage = lazy(() => import('./SalesAttritionReportPage'));

const SalesAttritionReportConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: AuthRoles.Reporting,
  routes: [
    {
      path: 'sales-closed-report',
      element: <SalesAttritionReportPage />,
    },
  ],
};

export default SalesAttritionReportConfig;
